import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Spring } from 'react-spring';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { WhitelabelActions, CounsellorsActions, alertActions, ReportsActions } from '../../store/actions';
import HeaderComponent from '../../components/Header';
import Footer from '../../components/Footer/footer';
import '../../static/css/styles.css';
import { constants } from '../../Constants';
import Select from 'react-select';
import moment from 'moment';

// import DatePicker from 'react-datepicker';

import DayPickerInput, { DateUtils } from 'react-day-picker/DayPickerInput';
// import 'react-day-picker/lib/style.css';
import 'react-day-picker/lib/style.css';
import { formatDate, parseDate } from 'react-day-picker/moment';

// import 'react-datepicker/dist/react-datepicker.css';
import { jsPDF } from 'jspdf';

import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

// import DayPicker from 'react-day-picker';
// import 'react-day-picker/lib/style.css';
import Popover from '@material-ui/core/Popover';
import { Typography } from '@material-ui/core';

class CounsellorReports extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			projectsSelected: [],
			startDate: undefined,
			endDate: undefined,
			from: undefined,
			to: undefined,
			counsellorSelected: [],
			isModalOpen: false,
			anchorEl: null,
			natureOfIssuesToDisplay: [],
		};
	}
	componentWillMount() {
		this.props.resetReports();
		this.props.fetchWhitelabel();
		this.props.fetchCounsellors();
	}
	showFromMonth = () => {
		const { from, to } = this.state;
		if (!from) {
			return;
		}
		if (moment(to).diff(moment(from), 'months') < 2) {
			this.to.getDayPicker().showMonth(from);
		}
	};

	handleFromChange = (from) => {
		// Change the from date and focus the "to" input field
		this.setState({ from });
	};

	handleToChange = (to) => {
		this.setState({ to }, this.showFromMonth);
	};
	onSearch = () => {
		const { from, to, startDate, endDate, projectsSelected, counsellorSelected } = this.state;

		let projects = [];
		if (projectsSelected && projectsSelected.length > 0) {
			projectsSelected.map((p) => {
				return projects.push(p.value);
			});
		}
		let counsellors = [];
		if (counsellorSelected && counsellorSelected.length > 0) {
			counsellorSelected.map((c) => {
				return counsellors.push(c.value);
			});
		}

		this.props.fetchSessionsData(
			`${moment(from).format('YYYY-MM-DD')}T00:00:00Z`,
			`${moment(to).format('YYYY-MM-DD')}T23:59:59Z`,
			projects.join(','),
			counsellors.join(',')
		);
	};

	changeProjects = (projectsSelected) => {
		this.setState({ projectsSelected });
	};

	changeCounsellors = (counsellorSelected) => {
		this.setState({ counsellorSelected });
	};

	exportPDF = (e) => {
		return false;
		/*const { reports } = this.props;
		const { data } = reports;
		if (data && data.length > 0) {
			e.preventDefault();

			const reportTemplate = (
				<div className="jumbotron mx-auto">
					<table className="borderless table table-responsive w-100 d-block d-md-table">
						<thead className="text-center table-head-styles">
							{data && data.length > 0 ? (
								<tr className="table-row-styles">
									<th scope="col session-heading">Counsellor</th>

									<th scope="col session-heading">Patient</th>
									<th scope="col session-heading">Patients Email </th>
									<th scope="col session-heading">Schedule</th>
									<th scope="col session-heading">Project</th>

									<th scope="col session-heading">Subsidary</th>
								</tr>
							) : (
								<tr className="text-center">
									<th scope="col session-heading">No appointments to show</th>
								</tr>
							)}
						</thead>
						<tbody className="text-center tableBody">
							{data &&
								data.map((item, i) => {
									return (
										<tr key={i} className="table-text">
											<td className="counsellorData">{item.counsellor_name}</td>
											<td className="counsellorData">{item.patient_name}</td>
											<td className="counsellorData">{item.patient_email}</td>
											<td className="counsellorData">
												{moment(item.date_time)
													.format('ddd DD MMM YYYY hh:mm:ss A')
													.toLocaleString('en-US', {
														hour: 'numeric',
														hour12: true,
													})}
											</td>
											<td className="counsellorData">{item.project_name}</td>
											<td className="counsellorData">{item.subsidiary_name}</td>
										</tr>
									);
								})}
						</tbody>
					</table>
				</div>
			);
			const doc = new jsPDF();

			doc.text(data.join(','), 10, 10);
			doc.save('a4.pdf');
		} else return false;*/
	};

	exportToCSV = (e) => {
		e.preventDefault();
		const { to, from } = this.state;
		const { reports } = this.props;
		const { data } = reports;
	  
		if (data && data.length > 0) {
		  const csvData = data;
		  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
		  const fileExtension = '.xlsx';
			const fileName = `Counsellor-Report-${moment(from).format('DD MMM YYYY')}-${moment(to).format(
				'DD MMM YYYY'
			)}`;
		  const formattedData = csvData.map((c) => {
			const issues = c.appointment_nature_of_issue && c.appointment_nature_of_issue.map(issue => issue.nature_of_issue.text).join(', ');
			c.date_time = moment(c.date_time).format('DD MMM YYYY hh:mm:ss A').toLocaleString('en-US', {
			  hour: 'numeric',
			  hour12: true,
			});
			return {
			  ...c,
			  appointment_nature_of_issue: issues,
			};
		  });
	  
			const ws = XLSX.utils.json_to_sheet(formattedData, {header: ['counsellor_name','subsidiary_name','date_time','project_name','patient_name','status','patient_email','patient_total_sessions_count', 'appointment_nature_of_issue',]}); // added headers for setting sequence of columns
		  const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
		  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
		  const dataSource = new Blob([excelBuffer], { type: fileType });
		  FileSaver.saveAs(dataSource, fileName + fileExtension);
		} else return false;
	  };
	  

	openModal = (e, issues) => {
		this.setState({ isModalOpen: true, anchorEl: e.currentTarget, natureOfIssuesToDisplay: issues });
	};

	closeModal = () => {
		this.setState({ isModalOpen: false, anchorEl: null, });
	};


	render() {
		const { from, to, projectsSelected, counsellorsSelected, natureOfIssuesToDisplay,isModalOpen,anchorEl } = this.state;

		const modifiers = { start: from, end: to };

		let optionsProjects = [];
		const { whitelabel, reports, counsellors } = this.props;
		const { data } = reports;
		if (whitelabel && whitelabel.length > 0) {
			whitelabel.map((w) => {
				return optionsProjects.push({ value: w.id, label: w.name });
			});
		}

		let counsellorOptions = [];
		if (counsellors && counsellors.length > 0) {
			counsellors.map(c => {
				return counsellorOptions.push({ value: c.counsellor_details.counsellor_id, label: c.user_details.full_name })
			})
		}

		return (
			<div className="ContainerFix">
				<HeaderComponent />
				<Spring from={{ transform: 'translate(+100%, 0)' }} to={{ transform: 'translate(0%, 0)' }}>
					{(props) => (
						<div className="containerFlex" style={props}>
							<div className="container-wrap">
								<div className="row mt-5 mx-auto w-75 pb-5" id="cardButtonContainer">
									{/* HEADING CONTAINER STARTS HERE */}
									<div className="heading-container">
										<p className="lead heading-line">{constants.Reports}</p>
										<div className="reports-search">
											<p className="lead heading-text col-md-7 col-sm-6 col-xs-12 p-0">
												{constants.COUNSELLOR_REPORTS_TXT} &nbsp;&nbsp;
												<span className="heading--sub">
													Last seen yesterday at 12:00 by Syed Naseh
												</span>
											</p>
											<form className="form-inline col-md-5 col-sm-6 col-xs-12 search-reports">
												{/* MAIN FILTER BUTTON */}
												<div className="counsellor-btns reports-btn"></div>
												{/* CENTER FILTER BUTTON */}
												<div className="counsellor-btns">
													<button
														className={`excel-btn cancel-submit-button width100 ${data && data.length > 0 ? '' : 'disableCursor'
															}`}
														onClick={this.exportToCSV}
													>
														{constants.EXCEL}
													</button>
													<button
														onClick={this.exportPDF}
														className={`appintment-submit-button width100 pdf-btn 
														disableCursor
													`}
													>
														{constants.PDF}
													</button>
												</div>
											</form>
										</div>
										<hr className="lead--heading-line" />
									</div>
									{/* HEADING CONTAINER ENDS HERE */}

									{/* FORM STARTS */}
									<div className='form-inline'>
										<div className="col-md-5 col-sm-12">
											<Select
												value={projectsSelected}
												isMulti
												name="projectsSelected"
												placeholder="Select project(s)"
												options={optionsProjects}
												className="basic-multi-select mr-sm-8 form-control form-control-lg search-input form-control-boder text text-left cstm-select"
												classNamePrefix="select"
												onChange={this.changeProjects}
											/>
										</div>
										<div className="col-md-5 col-sm-12">
											<Select
												value={counsellorsSelected}
												isMulti
												name="counsellorsSelected"
												placeholder="Select counsellor(s)"
												options={counsellorOptions}
												className="basic-multi-select mr-sm-8 form-control form-control-lg search-input form-control-boder text text-left cstm-select"
												classNamePrefix="select"
												onChange={this.changeCounsellors}
											/>

										</div>
									</div>
									<div className="form-inline">

										<div className="col-md-10 col-sm-12 counsellor-btns search-reports">
											<div className="form-control form-control-lg mr-sm-8 search-input form-control-boder">
												<div className="InputFromTo">
													<DayPickerInput
														value={from}
														placeholder="Start date"
														format="LL"
														formatDate={formatDate}
														parseDate={parseDate}
														id="stardDate"
														dayPickerProps={{
															selectedDays: [from, { from, to }],
															disabledDays: { after: to },
															toMonth: to,
															modifiers,
															numberOfMonths: 2,
															onDayClick: () => this.to.getInput().focus(),
														}}
														onDayChange={this.handleFromChange}
													/>{' '}
													—{' '}
													<span className="InputFromTo-To">
														<DayPickerInput
															ref={(el) => (this.to = el)}
															value={to}
															placeholder="End date"
															format="LL"
															id="endDate"
															formatDate={formatDate}
															parseDate={parseDate}
															dayPickerProps={{
																selectedDays: [from, { from, to }],
																disabledDays: { before: from },
																modifiers,
																month: from,
																fromMonth: from,
																numberOfMonths: 2,
															}}
															onDayChange={this.handleToChange}
														/>
													</span>
												</div>
											</div>
										</div>
										<div className="col-md-1 col-sm-12 counsellor-btns search-reports">
											<button
												className="btn btn-lg btn-counsellor dark-blue"
												aria-pressed="true"
												onClick={this.onSearch}
											>
												{constants.SEARCH_TXT}
											</button>
										</div>
										{/* FORM ENDS */}
									</div>

									{data ? (
										<div className="jumbotron mx-auto report-jumbotron">
											<table className="borderless table table-responsive w-100 d-block d-md-table reports-tbl">
												<thead className="text-center table-head-styles report-heading">
													<tr className="table-row-styles report-heading-row">
														<th scope="col session-heading">{constants.COUNSELLOR}</th>
														<th scope="col session-heading">{constants.PATIENTS}</th>
														<th scope="col session-heading" className='text-nowrap'>{constants.PATIENTS_EMAIL}</th>
														<th scope="col session-heading">{constants.SCHEDULE}</th>
														<th scope="col session-heading">{constants.PROJECT}</th>
														<th scope="col session-heading">{constants.SUBSIDIARY}</th>
														<th scope="col session-heading" className='text-nowrap'>{constants.NATURE_OF_ISSUE}</th>
														<th scope="col session-heading" className="report-border-right text-nowrap">{constants.NO_OF_TOTAL_SESSION}</th>
													</tr>
												</thead>
												{data && data.length > 1 ? (
													<tbody className="text-center tableBody report-table-body">
														{data &&
															data.map((item, i) => {
																const issues = item.appointment_nature_of_issue
																	? item.appointment_nature_of_issue.map((issue) => issue.nature_of_issue.text)
																	: [];
																if (item.total_records) {
																	return (
																		<tr key={i} className="table-text">
																			<td colSpan='8' className="counsellorData alignEnd">
																				{`${constants.SHOWING} ${item.total_records} ${constants.RECORDS}`}
																			</td>
																		</tr>
																	);
																} else
																	return (
																		<tr key={i} className="table-text">
																			<td className="counsellorData">
																				{item.counsellor_name}
																			</td>
																			<td className="counsellorData">
																				{item.patient_name}
																			</td>
																			<td className="counsellorData">
																				{item.patient_email}
																			</td>
																			<td className="counsellorData">
																				{moment(item.date_time)
																					.format('ddd DD MMM YYYY hh:mm:ss A')
																					.toLocaleString('en-US', {
																						hour: 'numeric',
																						hour12: true,
																					})}
																			</td>
																			<td className="counsellorData">
																				{item.project_name}
																			</td>
																			<td className="counsellorData">
																				{item.subsidiary_name}
																			</td>
																			<td className="counsellorData">
																				{issues.length > 0 ? (
																					<span>{issues.slice(0, 2).join(', ')}</span>
																				) : (
																					<span>{constants.NO_ISSUES_DISPLAY_TXT}</span>
																				)}
																				{issues.length > 2 && (
																					<React.Fragment>
																						<span>...</span>
																						<span className="see-more-btn text-nowrap" onClick={(e) => this.openModal(e, issues)}>
																							{`${constants.SEE_MORE.charAt(0).toUpperCase() + constants.SEE_MORE.slice(1).toLowerCase()}`}
																						</span>
																					</React.Fragment>
																				)}
																			</td>

																			<td className="counsellorData">
																				{item.patient_total_sessions_count}
																			</td>
																		</tr>
																	);
															})}
													</tbody>
												) : (
													<tbody>
														<tr className="text-center report-table-nobody">
															<td colSpan="8">{constants.NO_APPOINTMENTS_TXT}</td>
														</tr>
													</tbody>
												)}
											</table>
										</div>
									) : (
										''
									)}
								</div>
							</div>
							{isModalOpen && Array.isArray(natureOfIssuesToDisplay) && natureOfIssuesToDisplay.length > 0 && (
								<Popover
									id="simple-popper"
									open={isModalOpen}
									anchorEl={anchorEl}
									onClose={this.closeModal}
									anchorOrigin={{
										vertical: 'bottom',
										horizontal: 'center',
									}}
									transformOrigin={{
										vertical: 'top',
										horizontal: 'center',
									}}
									PaperProps={{
										style: { zIndex: 2,borderRadius: '12px', }
									}}
								>
									<Typography component={'span'} className="typography">
										<div className='issues-modal-content'>
											<div className='issues-modal-title'>
												{constants.NATURE_OF_ISSUE}
											</div>

											<div className='issues-modal-list-conatiner'>
												<ul id="issues-modal-description">
													{natureOfIssuesToDisplay.map((issue, index) => (
														<li key={index}>{issue}</li>
													))}
												</ul>
											</div>
											<button className='issues-modal-close-btn' onClick={this.closeModal}>Close</button>
										</div>
									</Typography>
								</Popover>
							)}
						</div>
					)}
				</Spring>
				<Footer />
			</div>
		);
	}
}

function mapStateToProps(state) {
	const { auth, alert, CounsellorReports, reports } = state;
	const { user } = auth;

	const authstate = state.auth;
	const { whitelabel } = state.whitelabel;
	const { counsellors, selectedCounsellor, loading } = state.counsellors;

	return {
		alert,
		user,
		authstate,
		whitelabel,
		reports,
		CounsellorReports,
		counsellors
	};
}

function mapDispatchToProps(dispatch) {
	return {
		fetchWhitelabel: () => {
			dispatch(WhitelabelActions.fetchWhitelabel());
		},
		fetchCounsellors: () => {
			dispatch(CounsellorsActions.fetchCounsellors());
		},
		fetchSessionsData: (startDate, endDate, projects, counsellors) => {
			dispatch(ReportsActions.fetchCounsellorReports(startDate, endDate, projects, counsellors));
		},
		resetReports: () => {
			dispatch(ReportsActions.resetReports());
		},
		clearAlertActions: () => {
			dispatch(alertActions.clear());
		},
		alertError: (message) => {
			dispatch(alertActions.error(message));
		},
		selectWhitelabel: (id) => {
			dispatch(WhitelabelActions.selectWhitelabel(id));
		},
	};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CounsellorReports));



// WEBPACK FOOTER //
// ./src/screens/CounsellorReports/index.js